import React, { useState, useEffect } from "react"
import { Container, Button } from "react-bootstrap"
import axios from "axios"
import AdminDasboardats from "./AdminDasboardats"
import { ProgressSpinner } from "primereact/progressspinner"
import Swal from "sweetalert2"
const SocialMedia = () => {
  const [companyOrgs, setCompanyOrgs] = useState([])
  const [loading, setLoading] = useState(false)
  const [toggleState, setToggleState] = useState({})
  const [assignedMap, setAssignedMap] = useState([])
  const [pendingSelection, setPendingSelection] = useState(null)

  const assignedOrgIds = new Set(
    assignedMap.filter(a => a.is_assigned).map(a => a.linkedin_details_id)
  )

  const userInfos = JSON.parse(sessionStorage.getItem("atsuser-info"))
  const companies = userInfos?.user_details?.companies_data || []
  // 🔹 GET ASSIGNED ORGS
  const fetchAssigned = async () => {
    const res = await axios.get("/api/v1/assign-linkedin-organisation/")
    setAssignedMap(res.data?.results || [])
    return res.data?.results || []
  }
  // 🔹 GET LINKEDIN ORGS + MERGE ASSIGN DATA
  // const fetchAll = async () => {
  //   setLoading(true)
  //   const assigned = await fetchAssigned()
  //   const data = []
  //   for (const company of companies) {
  //     const assignedEntry = assigned.find(
  //       a => a.company_id === company.company_id
  //     )
  //     const res = await axios.get("/api/v1/linkedin-details/", {
  //       params: { company_id: company.company_id },
  //     })
  //     const orgs = res.data?.results.map(org => ({
  //       ...org,
  //       is_assigned:
  //         assignedEntry?.is_assigned &&
  //         assignedEntry?.linkedin_details_id === org.id,
  //     }))
  //     data.push({
  //       companyId: company.company_id,
  //       companyName: company.company_name,
  //       orgs,
  //     })
  //     // 🔹 pre-select toggle if already assigned
  //     if (assignedEntry?.is_assigned) {
  //       setToggleState(prev => ({
  //         ...prev,
  //         [company.company_id]: assignedEntry.linkedin_details_id,
  //       }))
  //     }
  //   }
  //   setCompanyOrgs(data)
  //   setLoading(false)
  // }
  const fetchAll = async () => {
  setLoading(true)

  const assigned = await fetchAssigned()

  const firstCompanyId = companies[0]?.company_id
  if (!firstCompanyId) {
    setLoading(false)
    return
  }

  // 🔹 single API call
  const res = await axios.get("/api/v1/linkedin-details/", {
    params: { company_id: firstCompanyId },
  })

  const orgs = res.data?.results || []

  // 🔹 build rows only from sessionStorage companies
  const data = companies.map(company => {
    const assignedEntry = assigned.find(
      a => a.company_id === company.company_id && a.is_assigned
    )

    // preselect assigned toggle
    if (assignedEntry) {
      setToggleState(prev => ({
        ...prev,
        [company.company_id]: assignedEntry.linkedin_details_id,
      }))
    }

    return {
      companyId: company.company_id,
      companyName: company.company_name,
      orgs: orgs.map(org => ({
        ...org,
        is_assigned:
          assignedEntry?.linkedin_details_id === org.id &&
          assignedEntry?.is_assigned,
      })),
    }
  })

  setCompanyOrgs(data)
  setLoading(false)
}

  useEffect(() => {
    if (companies.length) fetchAll()
  }, [])
  const handleToggle = (companyId, orgId) => {
    setToggleState(prev => ({
      ...prev,
      [companyId]: orgId,
    }))

    setPendingSelection({
      companyId,
      orgId,
    })
  }

  const handleConnect = async () => {
    if (!pendingSelection) {
      Swal.fire("Warning", "Please select an organization", "warning")
      return
    }

    const { companyId, orgId } = pendingSelection

    await axios.post("/api/v1/assign-linkedin-organisation/", {
      mappings: [
        {
          company_id: Number(companyId),
          linkedin_details_id: orgId,
        },
      ],
    })

    await fetchAll()

    setPendingSelection(null) // reset after success

    Swal.fire("Success", "Successfully connected", "success")
  }

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <ProgressSpinner />
      </div>
    )
  }
  const allOrgs = []
  companyOrgs.forEach(c =>
    c.orgs.forEach(o => {
      if (!allOrgs.find(x => x.id === o.id)) allOrgs.push(o)
    })
  )
  return (
    <Container fluid>
      <div className="tabsmargin">
        <AdminDasboardats />
        <div className="container-fluid mt-3">
          <h4 className="mb-3 text-center p-3">Linkedin Mapping</h4>
          <table className="table table-bordered align-middle">
            <thead className="table-light">
              <tr>
                <th
                  rowSpan="2"
                  className="text-center"
                  style={{ width: "25%" }}
                >
                  Companies
                </th>
                <th colSpan={allOrgs.length} className="text-center">
                  Organizations
                </th>
              </tr>
              <tr>
                {allOrgs.map(org => (
                  <th key={org.id} className="text-center">
                    {org.organisation_name}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {companyOrgs.map(company => (
                <tr key={company.companyId}>
                  <td>
                    <strong>{company.companyName}</strong>
                  </td>
                  {allOrgs.map(org => {
                    const orgData = company.orgs.find(o => o.id === org.id)
                    console.log("orgData", orgData)
                    return (
                      // <td key={org.id} className="text-center">
                      //   {orgData ? (
                      //     <input
                      //       type="checkbox"
                      //       className="form-check-input"
                      //       checked={toggleState[company.companyId] === org.id}
                      //       // disabled={orgData.is_assigned}
                      //       disabled={
                      //         assignedOrgIds.has(org.id) &&
                      //         toggleState[company.companyId] !== org.id
                      //       }
                      //       title={
                      //         assignedOrgIds.has(org.id) &&
                      //         toggleState[company.companyId] !== org.id
                      //           ? "This organization is already connected. Only one organization can be connected to one company."
                      //           : ""
                      //       }
                      //       onChange={() =>
                      //         handleToggle(
                      //           company.companyId,
                      //           org.id,
                      //           orgData.is_assigned
                      //         )
                      //       }
                      //     />
                      //   ) : (
                      //     "-"
                      //   )}
                      // </td>
                      <td key={org.id} className="text-center">
                        {orgData ? (
                          <span
                            title={
                              assignedOrgIds.has(org.id) &&
                              toggleState[company.companyId] !== org.id
                                ? "This organization is already assigned. Only one organization may be linked to a company.   "
                                : ""
                            }
                            style={{ cursor: "not-allowed" }}
                          >
                            <input
                              type="checkbox"
                              className="form-check-input"
                              checked={
                                toggleState[company.companyId] === org.id
                              }
                              disabled={
                                assignedOrgIds.has(org.id) &&
                                toggleState[company.companyId] !== org.id
                              }
                              onChange={() =>
                                handleToggle(company.companyId, org.id)
                              }
                            />
                          </span>
                        ) : (
                          "-"
                        )}
                      </td>
                    )
                  })}
                </tr>
              ))}
            </tbody>
          </table>
          <div className="d-flex justify-content-center mt-4">
            <Button onClick={handleConnect}>Connect to Organization</Button>
          </div>
        </div>
      </div>
    </Container>
  )
}
export default SocialMedia
